function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ipad-landscape",
  transform: "translate(28.15 -68.117) rotate(90)",
  opacity: 0.9
}, React.createElement("path", {
  id: "Path_3050",
  "data-name": "Path 3050",
  d: "M68.734,23.92a.5.5,0,0,0,.467-.52V2.6a1.634,1.634,0,0,1,1.4-1.56H86.467a1.634,1.634,0,0,1,1.4,1.56.469.469,0,1,0,.933,0A2.611,2.611,0,0,0,86.467,0H70.6a2.611,2.611,0,0,0-2.333,2.6V23.4A.5.5,0,0,0,68.734,23.92Z",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_3051",
  "data-name": "Path 3051",
  d: "M88.334,68.267H70.6a.435.435,0,1,0,0,.868H87.867V88.658a1.488,1.488,0,0,1-1.4,1.3H70.6a1.488,1.488,0,0,1-1.4-1.3V86.488H86.467a.435.435,0,1,0,0-.868H68.734a.451.451,0,0,0-.467.434v2.6A2.377,2.377,0,0,0,70.6,90.827H86.467A2.377,2.377,0,0,0,88.8,88.658V68.7A.451.451,0,0,0,88.334,68.267Z",
  transform: "translate(0 -62.827)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_3052",
  "data-name": "Path 3052",
  d: "M248.357,34.133a.683.683,0,1,0,.007,0Z",
  transform: "translate(-169.815 -31.413)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_3054",
  "data-name": "Path 3054",
  d: "M238.933,445.093a1.36,1.36,0,1,0,1.36-1.36A1.361,1.361,0,0,0,238.933,445.093Z",
  transform: "translate(-161.759 -420.173)",
  fill: "#403f50",
  stroke: "#403f50",
  strokeWidth: 0.3
}), React.createElement("path", {
  id: "Path_3066",
  "data-name": "Path 3066",
  d: "M9808.6-23.328v3.087l.94.063v-3.15Z",
  transform: "translate(-9720.733 26)",
  fill: "#525161",
  stroke: "#403f50",
  strokeWidth: 0.3
}));
var SvgIpadLandscape = function SvgIpadLandscape(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 28.301,
    height: 20.836,
    viewBox: "0 0 28.301 20.836",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIpadLandscape, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ipad-landscape.7c2a44f5.svg";
export { ForwardRef as ReactComponent };